import React from 'react'
import classes from './styles.module.scss'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import { WhiteSpace } from 'antd-mobile'
import _ from 'lodash'

export default class MapCard extends React.Component {
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }

  call = (e, mobile) => {
    e.stopPropagation()
    window.location.href = `tel:${mobile}`
  }

  render() {
    const item = this.props
    const mobile = item.mobile || item.tel
    const name = item.merchantName || item.name
    const distance = item.distance || _.get(item, 'distanceParam.value')
    return (
      <div className={classes.componentsMapCard} onClick={item.onClick}>
        <div className={classes.merchantName}>{name}</div>
        <WhiteSpace size='xs' />
        <div className='font-xs black'>
          {item.businessHours && (
            <React.Fragment>
              <FormattedMessage {...messages.businessHour} />{' '}
              {item.businessHours}
            </React.Fragment>
          )} &nbsp;
        </div>
        {mobile && (
          <a onClick={(e) => this.call(e, mobile)}>
            <span className='iconfont iconMerchant-callphone green font-lg' />
          </a>
        )}
        <WhiteSpace size='xs' />
        <div className='gray font-xs'>
          {distance && `${_.toNumber(distance).toFixed(2)}KM - `}
          {item.address} {item.city && ` - ${item.city}`}
        </div>
      </div>
    )
  }
}
